import createDependenciesCollector from "./utils/create-dependencies-collector";

const getForReasonsForMeeting = createDependenciesCollector(["PositiveSelectionV2"]);

export default getForReasonsForMeeting;
